export default __webpack_public_path__ + "static/media/method-flow.c68beba5.png";